<p *ngIf="isAfficherInfos" class="dsd-b-30 dsd-fw-bold">{{ 'caad.modifier.coordonnees.ajoutedechamps' | translate }}</p>
<form class="dsd-p-0 form-telephone" [formGroup]="controleFormGroup">
  <dsd-container>
    <dsd-fieldset aria-describedby="avis" [quietValidate]="true">
      <span slot="legend"
        ><h2 class="dsd-t-4 dsd-fw-bold" tabindex="-1">
          {{
            'caad.modifier.telephone.' +
              (!coordonneesClient?.telephones || coordonneesClient?.telephones.length <= 1
                ? 'numeroTelephone'
                : 'numerosTelephones') | translate
          }}
        </h2></span
      >

      <span slot="description">
        <div
          class="dsd-d-flex conteneur-supression"
          id="avis"
          role="region"
          aria-labelledby="region-avis"
          *ngIf="isSupression"
          tabindex="-1">
          <h3 id="region-avis">
            <dsd-icon
              class="icon-avertissement"
              [srOnlySuffix]="'caad.modifier.telephone.libelle.avis' | translate"
              icon-name="alertes_contour_avertissement"></dsd-icon>
          </h3>
          <p>{{ 'caad.accueil.alerte.impossibleDeSupprimerUnNumero' | translate }}</p>
        </div>
      </span>
      <dsd-fieldset
        [quietValidate]="true"
        [ngClass]="{ 'ligne-horizontale': isSecondNumeroActif, 'fieldset-principal': !isSecondNumeroActif }">
        <span
          slot="legend"
          class="dsd-sr-only"
          [innerHtml]="'caad.libelle.premierNumeroDeTelephoneLiseuse' | translate"></span>
        <dsd-input
          class="dsd-mb-0"
          input-width="26.7"
          identifier="principal"
          formControlName="principal"
          name="principal"
          required="true"
          maxlength="12"
          [quietValidate]="true"
          [error]="erreursFormTelephone.principal.hasError"
          custom-type="tel">
          <span slot="label">{{ 'caad.modifier.telephone.libelle.numerotelephoneprincipal' | translate }}</span>
          <span slot="error"
            ><app-erreur-input-telephone [erreurInput]="erreursFormTelephone.principal"></app-erreur-input-telephone
          ></span>
          <span slot="hint">{{ 'caad.modifier.telephone.libelle.hint' | translate }}</span>
        </dsd-input>
        <!-- Bouton pour afficher la première liste déroulante -->
        <div *ngIf="!isSecondNumeroActif">
          <dsd-button
            class="dsd-mt-sm"
            variant="compact"
            (dsdButtonClick)="isSecondNumeroActif = true; accessibiliteService.setFocus('#selectSecondaire')"
            >{{ 'caad.button.ajouter' | translate }}</dsd-button
          >
        </div>
      </dsd-fieldset>

      <!-- Première liste déroulante et numéro #2 -->
      <div *ngIf="isSecondNumeroActif" class="info-block">
        <dsd-fieldset [quietValidate]="true">
          <span slot="legend">
            <span [innerHtml]="'caad.libelle.deuxiemeNumeroDeTelephone' | translate" aria-hidden="true"></span>
            <span class="dsd-sr-only">{{ 'caad.libelle.deuxiemeNumeroDeTelephoneLiseuse' | translate }}</span>
          </span>
          <span *ngIf="isAfficherListe" class="dsd-pl-sm">
            <ng-container *ngTemplateOutlet="ChoixSelect; context: { section: 2 }"></ng-container>
          </span>
          <div *ngIf="typeNumeroDeux">
            <div class="tel-double dsd-pl-sm">
              <ng-container
                *ngTemplateOutlet="
                  typeNumeroDeux === 'SECONDAIRE' ? ChampsNumeroSecondaire : ChampsNumeroEmployeur
                "></ng-container>
            </div>
            <dsd-button
              class="dsd-mt-sm"
              variant="compact"
              *ngIf="!isTroisiemeNumeroActif"
              (dsdButtonClick)="ajouterDernierChamps()"
              >{{ 'caad.button.ajouter' | translate }}</dsd-button
            >
          </div>
        </dsd-fieldset>
      </div>

      <div *ngIf="isTroisiemeNumeroActif">
        <dsd-fieldset [quietValidate]="true">
          <span slot="legend">
            <span [innerHtml]="'caad.libelle.troisiemeNumeroDeTelephone' | translate" aria-hidden="true"></span>
            <span class="dsd-sr-only">{{ 'caad.libelle.troisiemeNumeroDeTelephoneLiseuse' | translate }}</span>
          </span>
          <span *ngIf="isAfficherListe" class="dsd-pl-sm">
            <ng-container *ngTemplateOutlet="ChoixSelect; context: { section: 3 }"></ng-container>
          </span>
          <div *ngIf="typeNumeroDeux" class="tel-double dsd-pl-sm">
            <ng-container
              *ngTemplateOutlet="
                typeNumeroDeux === 'EMPLOYEUR' ? ChampsNumeroSecondaire : ChampsNumeroEmployeur
              "></ng-container>
          </div>
        </dsd-fieldset>
      </div>
    </dsd-fieldset>
  </dsd-container>

  <div class="zone-btn">
    <dsd-button variant="primary" (dsdButtonClick)="onSubmit()" full-width="xs">{{
      'caad.button.valider' | translate
    }}</dsd-button>
    <dsd-button (dsdButtonClick)="annulerModification()" full-width="xs">{{
      'caad.button.annuler' | translate
    }}</dsd-button>
  </div>
  <!--  Liste déroulante -->
  <ng-template #ChoixSelect let-section="section">
    <dsd-select
      identifier="selectSecondaire"
      value="{{ typeNumeroDeux }}"
      class="widht-liste{{ section }} dsd-pb-md"
      hide-required-labelling="true"
      (change)="onChoixChange($event)"
      name="dsd-select-simple"
      [noDefaultOption]="isTroisiemeNumeroActif">
      <span slot="label">{{ 'caad.select.typede' | translate }}</span>
      <span slot="options" dsd-select-input-wrapper>
        <option
          *ngFor="
            let choix of (section === 2 ? (isTroisiemeNumeroActif ? [typeNumeroDeux] : choixInput) : [typeNumeroTrois])
              | displayDonneesRef: 'caad.select.'
          "
          [value]="choix">
          {{ 'caad.select.' + choix.toLowerCase() | translate }}
        </option>
      </span>
    </dsd-select>
  </ng-template>

  <!--  Section téléphone secondaire -->
  <ng-template #ChampsNumeroSecondaire>
    <!-- <div class="dsd-d-block"> -->
    <dsd-input
      input-width="26.7"
      [required]="isSecondaireRequired"
      identifier="secondaire"
      formControlName="secondaire"
      name="secondaire"
      maxlength="12"
      [quietValidate]="true"
      [error]="erreursFormTelephone.secondaire.hasError"
      custom-type="tel">
      <span slot="label">{{ 'caad.modifier.telephone.libelle.numerotelephonesecondaire' | translate }}</span>
      <span slot="error"
        ><app-erreur-input-telephone [erreurInput]="erreursFormTelephone.secondaire"></app-erreur-input-telephone
      ></span>
      <span slot="hint">{{ 'caad.modifier.telephone.libelle.hint' | translate }}</span>
    </dsd-input>
    <!-- </div> -->
  </ng-template>

  <!--  Section téléphone employeur -->
  <ng-template #ChampsNumeroEmployeur>
    <dsd-input
      input-width="26.7"
      identifier="employeur"
      class="dsd-mr-md"
      formControlName="employeur"
      name="employeur"
      maxlength="12"
      [required]="isEmployeurRequired"
      [quietValidate]="true"
      [error]="erreursFormTelephone.employeur.hasError"
      custom-type="tel">
      <span slot="label">{{ 'caad.modifier.telephone.libelle.numerotelephoneemployeur' | translate }}</span>
      <span slot="error"
        ><app-erreur-input-telephone [erreurInput]="erreursFormTelephone.employeur"></app-erreur-input-telephone
      ></span>
      <span slot="hint">{{ 'caad.modifier.telephone.libelle.hint' | translate }}</span>
    </dsd-input>

    <dsd-input
      input-width="10.8"
      identifier="numeroPoste"
      class="poste"
      formControlName="numeroPoste"
      name="numeroPoste"
      (keydown)="getPosteNumerique($event)"
      [quietValidate]="true"
      [error]="erreursFormTelephone.numeroPoste.hasError"
      hide-required-labelling="false">
      <span slot="label">{{ 'caad.modifier.telephone.libelle.poste' | translate }}</span>
      <span slot="error"
        ><app-erreur-input-telephone [erreurInput]="erreursFormTelephone.numeroPoste"></app-erreur-input-telephone
      ></span>
      <span slot="hint">{{ 'caad.modifier.telephone.libelle.exemplePoste' | translate }}</span>
    </dsd-input>
  </ng-template>
</form>
